import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginWithRecoveryCode } from '@core/store/auth/auth.action';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Component({
	selector: 'app-login-with-recovery-code',
	templateUrl: './login-with-recovery-code.component.html',
	styleUrls: ['./login-with-recovery-code.component.scss'],
})
export class LoginWithRecoveryCodeComponent implements OnInit {
	error = false;
	loading = false;
	authForm = new UntypedFormGroup({
		recoveryCode: new UntypedFormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
	});

	constructor(private store: Store) {}

	ngOnInit(): void {}

	onLogin() {
		this.error = null;
		this.loading = true;

		const recoveryCode = this.authForm.value.recoveryCode.trim();
		this.store.dispatch(new LoginWithRecoveryCode(recoveryCode)).subscribe({
			next: () => this.store.dispatch(new Navigate(['/'])),
			error: () => this.handleLoginError(),
		});
	}

	handleLoginError() {
		this.error = true;
		this.loading = false;
		this.authForm.setErrors({ invalidAuthCode: true });
	}
}
